import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftSLine } from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { popUpBoxTrigger } from "../../features/message/popUpSlice";
import axios from "axios";
import { baseUrl } from "../../utils/constant";

const TrackAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [artists, setArtists] = useState([]);
  const [categories, setCategories] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    artist_id: "",
    category_id: "",
    language_id: "",
    status: 1,
    release_date: "",
    cover_image: null,
    music_track: null,
  });

  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [artistRes, categoryRes, languageRes] = await Promise.all([
          axios.get(`${baseUrl}admin/artist/list`, { headers: { Authorization: "Bearer " + token } }),
          axios.get(`${baseUrl}admin/category/list`, { headers: { Authorization: "Bearer " + token } }),
          axios.get(`${baseUrl}admin/language/list`, { headers: { Authorization: "Bearer " + token } }),
        ]);
        setArtists(artistRes.data.data.artist || []);
        setCategories(categoryRes.data.data.getCategory || []);
        setLanguages(languageRes.data.data.languages || []);
      } catch (err) {
        dispatch(popUpBoxTrigger({ type: "error", heading: "Error", message: "Failed to load dropdown data." }));
      }
    };
    fetchDropdowns();
  }, []);

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) setFormData({ ...formData, [field]: file });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { title, description, artist_id, category_id, language_id, release_date, cover_image, music_track } = formData;

    if (!title || !description || !artist_id || !category_id || !language_id || !release_date || !cover_image || !music_track) {
      dispatch(popUpBoxTrigger({ type: "error", heading: "Error", message: "Please fill all fields." }));
      return;
    }

    setLoading(true);
    const payload = new FormData();
    payload.append("title", title);
    payload.append("description", description);
    payload.append("track_duration", 0);
    payload.append("artist_id", artist_id);
    payload.append("category_id", category_id);
    payload.append("language_id", language_id);
    payload.append("status", formData.status);
    payload.append("release_date", release_date);
    payload.append("cover_image", cover_image);
    payload.append("music_track", music_track);

    try {
      const res = await axios({
        method: "POST",
        url: `${baseUrl}admin/music-track/create`,
        data: payload,
        headers: { Authorization: "Bearer " + token },
      });

      if (res.data.status === 200) {
        setLoading(false);
        dispatch(popUpBoxTrigger({ type: "success", heading: "Success", message: res.data.message }));
        navigate("/track");
      } else {
        setLoading(false);
        dispatch(popUpBoxTrigger({ type: "error", heading: "Error", message: "Something went wrong." }));
      }
    } catch (err) {
      setLoading(false);
      const msg = err.response?.data?.message || "Something went wrong.";
      dispatch(popUpBoxTrigger({ type: "error", heading: "Error", message: msg }));
    }
  };

  const inputStyle = { width: "100%", padding: "10px 14px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "14px", marginTop: "6px", boxSizing: "border-box" };
  const labelStyle = { fontSize: "13px", fontWeight: "600", color: "#555" };
  const fieldStyle = { display: "flex", flexDirection: "column", marginBottom: "18px" };

  return (
    <div style={{ padding: "24px" }}>
      <div style={{ background: "#fff", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
          <h3 style={{ margin: 0, fontSize: "18px" }}>Upload Track</h3>
          <button onClick={() => navigate("/track")} style={{ display: "flex", alignItems: "center", gap: "4px", background: "none", border: "1px solid #ddd", borderRadius: "8px", padding: "8px 14px", cursor: "pointer", fontSize: "13px" }}>
            <RiArrowLeftSLine /> Track List
          </button>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 24px" }}>
          <div style={fieldStyle}>
            <label style={labelStyle}>Title</label>
            <input style={inputStyle} type="text" placeholder="Track title" onChange={(e) => setFormData({ ...formData, title: e.target.value })} />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Description</label>
            <input style={inputStyle} type="text" placeholder="Track description" onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Release Date</label>
            <input style={inputStyle} type="date" onChange={(e) => setFormData({ ...formData, release_date: e.target.value })} />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Artist</label>
            <select style={inputStyle} onChange={(e) => setFormData({ ...formData, artist_id: e.target.value })}>
              <option value="">Select Artist</option>
              {artists.map((a) => <option key={a.id} value={a.id}>{a.artist_name}</option>)}
            </select>
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Category</label>
            <select style={inputStyle} onChange={(e) => setFormData({ ...formData, category_id: e.target.value })}>
              <option value="">Select Category</option>
              {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Language</label>
            <select style={inputStyle} onChange={(e) => setFormData({ ...formData, language_id: e.target.value })}>
              <option value="">Select Language</option>
              {languages.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
            </select>
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Status</label>
            <select style={inputStyle} onChange={(e) => setFormData({ ...formData, status: e.target.value })}>
              <option value="1">Publish</option>
              <option value="0">Unpublish</option>
            </select>
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Cover Image (JPG/PNG)</label>
            <input style={inputStyle} type="file" accept=".png,.jpg,.jpeg" onChange={(e) => handleFileChange(e, "cover_image")} />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Audio File (MP3)</label>
            <input style={inputStyle} type="file" accept=".mp3,audio/*" onChange={(e) => handleFileChange(e, "music_track")} />
          </div>
        </div>

        <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
          <button onClick={handleSubmit} style={{ background: "#0d9488", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 28px", cursor: "pointer", fontSize: "14px", fontWeight: "600", display: "flex", alignItems: "center", gap: "6px" }}>
            {loading ? <AiOutlineLoading3Quarters /> : "Upload Track"}
          </button>
          <button onClick={() => navigate("/track")} style={{ background: "none", border: "1px solid #ddd", borderRadius: "8px", padding: "10px 28px", cursor: "pointer", fontSize: "14px" }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrackAdd;
